import React from "react";
import "./App.css";
import Countries from "./features/countries/Countries";
import India from "./features/india/India";
import { HashRouter as Router, Route } from "react-router-dom";
import Navbar from "./navbar/Navbar";
import Countrieschart from "./features/countries-chart/Countrieschart";
import Footer from "./footer/Footer";
import Usa from "./features/usa/Usa";
import UsaCharts from "./features/usaCharts/UsaCharts";
import Thanks from "./thanks/Thanks";
import Info from "./info/Info";
import Canada from "./features/canada/Canada";
import Canadacharts from "./features/canadaCharts/CanadaCharts";

function App() {
  return (
    <Router>
      <div className="App-header App">
        <Navbar />
        <Route path="/" exact component={Countries} />
        <Route path="/india" component={India} />
        <Route path="/usa" component={Usa} />
        <Route path="/usachart/:state" component={UsaCharts} />
        <Route path="/canada/" component={Canada} />
        <Route path="/canadachart/:province" component={Canadacharts} />
        <Route path="/countries" component={Countries} />
        <Route path="/countrieschart/:country" component={Countrieschart} />
        <Route path="/thanks" component={Thanks} />
        <Route path="/info" component={Info} />
      </div>
      <Footer />
    </Router>
  );
}

export default App;
